/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalFormData
 */
export interface SupplementalFormData {
    /**
     * 
     * @type {any}
     * @memberof SupplementalFormData
     */
    form_data?: any | null;
}

/**
 * Check if a given object implements the SupplementalFormData interface.
 */
export function instanceOfSupplementalFormData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalFormDataFromJSON(json: any): SupplementalFormData {
    return SupplementalFormDataFromJSONTyped(json, false);
}

export function SupplementalFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_data': !exists(json, 'form_data') ? undefined : json['form_data'],
    };
}

export function SupplementalFormDataToJSON(value?: SupplementalFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_data': value.form_data,
    };
}

